import { getRequest } from '../services/requestHandler';
import type { Tournament } from '../models';

export const getTournaments = async () => {
  const response = await getRequest<Tournament>('getTournaments', 'Tournament/GetTournaments?activeOnly=true');
  return response;
};
